import React , { Component, useRef, useEffect }from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as actionCreators from 'store/actions';

import Bar from './Bar';
import { BarModal } from 'features'
import { TimeGrid } from 'react-big-calendar';

const Container = styled.div`
    height: 10rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    overflow-x: scroll;
`

const StatLabel = styled.div`
    font-size: 0.8rem;
    color: var(--secondary-accent-color);
    white-space: nowrap;
    margin-top: 0.2rem;
`

const Label = styled.div`
    display: flex;
    flex-direction: column;
    align-items:center;
`

class BarChart extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.ref.current && this.ref.current.scrollTo(this.ref.current.scrollWidth, 0)
    }

    onSelect = (day) => {
        if(this.props.onSelect){
            this.props.onSelect(day)
        } else {
            this.props.setModal(<BarModal values={day}/>, day.x)
        }
    }

    render(){       
        let blocks = []
        const maxValue = _.maxBy(Object.values(this.props.values), 'y')['y']
        Object.values(this.props.values).map((day, index) => {
            const percent = `${Math.round((day['y'] / maxValue)*100)}%`
            const tooltip = <Label>
                                <div>{day.y} completed</div>
                                <div>({day.x})</div>
                            </Label>
            blocks.push(<Bar key={day.x} orientation='vertical' percent={percent} tooltip={tooltip} showPercentage={false} 
                            width='1rem' margin='0 0.5rem 0 0'
                            primaryColor='transparent' secondaryColor={index === Object.keys(this.props.values).length-1 ? 'var(--focus-color)' : null}
                            onSelect={() => this.onSelect(day)}
                            />)
        })

        return (
            <div>
                <Container ref={this.ref}>
                    {blocks}
                </Container>
                <StatLabel>{`Completed in the last ${Object.values(this.props.values).length} ${Object.values(this.props.values).length === 0 ? "day" : "days"}`}</StatLabel>
            </div>
        )
    }
    
}

const mapStateToProps = state => {
    return {
        
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BarChart);

